(() => {
  "use strict";

  // Add modal functionality
  const modal = document.querySelector('.preorder-modal-overlay');
  const closeBtn = document.querySelector('.preorder-modal-close');

  function openModal() {
    modal.style.display = 'flex';
  }

  function closeModal() {
    modal.style.display = 'none';
  }

  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });
  class t {
    static ATC_PRE_ORDER_TITLE = "Pre Order";
    static DEFAULT_SHIPMENT_MESSAGE = "Estimated to Ship on";
    static ATC_SELECTOR = 'form[action="/cart/add"] button[name="add"]';
    static MESSAGE_SELECTOR = ".product-info__add-to-cart";
    static DATA_PREORDER_MESSAGE_SELECTOR = "[data-pre-order-message]";
    static FORM_SELECTOR = 'product-form form[action="/cart/add"]';
    static PROPERTY_SELECTOR = "[data-pre-order-property]";
    static TEMPLATE = window.ElsPreOrder?.template ?? null;
    static IS_ONLY_CUSTOMER = !!window.ElsPreOrder?.isOnlyCustomer ?? !1;
    static PRODUCT = window.ElsPreOrder?.product ?? null;
    static VARIANTS = window.ElsPreOrder?.variants ?? [];
    static SHIPMENTS = window.ElsPreOrder?.shipments ?? [];
    static CUSTOMER = window.ElsPreOrder?.customer ?? null;
    static CUSTOMER_IS_SPECIAL = t.CUSTOMER && !!t.CUSTOMER?.isSpecial;
    static getProduct = () => t.PRODUCT;
    static isProductPage = () => "product" === t.TEMPLATE;
    static isShopifyContinue = t => "shopify" === t?.inventory_management && "continue" === t?.inventory_policy;
    static getShipments = e => t.SHIPMENTS[e] ?? [];
    static getQuantityFromShipments = e => t.getShipments(e).reduce(((t, e) => t + e.quantity), 0);
    static getAtcButtons = () => Array.from(document.querySelectorAll(t.ATC_SELECTOR));
    static getMessageElement = () => document.querySelector(t.DATA_PREORDER_MESSAGE_SELECTOR);
    static getMessagePlaceElement = () => document.querySelector(t.MESSAGE_SELECTOR);
    static getFormElement = () => document.querySelector(t.FORM_SELECTOR);
    static getPropertyInputElements = () => Array.from(document.querySelectorAll(t.PROPERTY_SELECTOR));
    static getShipmentMessage = (e, n = "") => n + (e?.message?.length ? e.message : `${t.DEFAULT_SHIPMENT_MESSAGE} ${e?.eta_at}`);
    static getPreOrderName = e => e?.po_name?.length ? e.po_name : t.getShipmentMessage(e);
    static extractDateFromMessage = message => {
      const dateRegex = /(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|January|February|March|April|May|June|July|August|September|October|November|December)\s+(\d{1,2})(?:st|nd|rd|th)?/i;
      const match = message.match(dateRegex);
      if (match) {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const fullMonthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        let month = match[1];
        const day = parseInt(match[2], 10);
        
        const fullMonthIndex = fullMonthNames.findIndex(m => m.toLowerCase() === month.toLowerCase());
        if (fullMonthIndex !== -1) {
          month = monthNames[fullMonthIndex];
        }
        
        return `${month} ${day}`;
      }
      return '';
    }
  }
  
  class e {
    getPrepareVariant(e) {
      const n = t.VARIANTS.find((t => +t.id == +e.id)),
        r = n ? n.inventory_quantity : e.inventory_quantity,
        i = t.getShipments(e.id);
      if (t.isShopifyContinue(e) && r <= 0 && i?.length) {
        const n = this._getCommonQuantity(e),
          r = {
            inventory_quantity: n,
            available: !1,
            preorder: !1
          };
        if (n > 0) {
          const e = t.IS_ONLY_CUSTOMER && (!t.CUSTOMER || !t.CUSTOMER_IS_SPECIAL);
          r.available = !e, r.preorder = !e
        }
        e = {
          ...e,
          ...r
        }
      }
      return e
    }
    
    renderPreOrderButton = (e, n) => {
      const r = t.getAtcButtons();
      if (r?.length)
        if (e?.preorder && t.getShipments(e.id)?.length) {
          const n = this._getVariantShipment(e);
          if (!n) return;
          const i = t.getShipmentMessage(n);
          r.map((e => {
            e.disabled = !1, e.textContent = t.ATC_PRE_ORDER_TITLE, this._renderMessage(i), this._renderProperties([{
              key: "Preorder",
              value: i
            }, {
              key: "Shipment",
              value: t.getPreOrderName(n)
            }, {
              key: "_shipdate",
              value: t.extractDateFromMessage(i)
            }])
          }))
        } else this._removeMessage(), this._removeProperties(), "function" == typeof n && n(r)
    };
    
    _getCommonQuantity = e => {
      const n = t.VARIANTS.find((t => +t.id == +e.id)),
        r = n ? n.inventory_quantity : e.inventory_quantity;
      return t.getQuantityFromShipments(e.id) + r
    };
    
    _getVariantShipment = e => {
      const n = t.VARIANTS.find((t => +t.id == +e.id));
      let r = n ? n.inventory_quantity : e.inventory_quantity;
      const i = t.SHIPMENTS[e.id];
      if (!i?.length) return null;
      for (let t in i)
        if (r += i[t].quantity, r > 0) return i[t];
      return null
    };
    
    _renderMessage = e => {
      const n = t.getMessageElement();
      if (n) n.textContent = e;
      else {
        const n = t.getMessagePlaceElement();
        if (!n) return;
        const r = t.DATA_PREORDER_MESSAGE_SELECTOR.replace("[", "").replace("]", ""),
          i = "width: 100%; font-weight: bold; margin-top: 20px; font-size: 14px;";
        n.insertAdjacentHTML("afterend", `
          <div class="preorder-message-container">
            <div ${r} style="${i}">${e}</div>
            <a class="preorder-info-link" onclick="event.preventDefault(); document.querySelector('.preorder-modal-overlay').style.display='flex';">
              about pre-order dates
            </a>
          </div>
        `);
      }
    };
    
    _removeMessage = () => {
      const e = t.getMessageElement();
      e && e.closest('.preorder-message-container')?.remove();
    };
    
    _renderProperties(e = null) {
      this._removeProperties();
      const n = t.getFormElement();
      if (e?.length > 0 && n) {
        const r = t.PROPERTY_SELECTOR.replace("[", "").replace("]", "");
        e.map((t => {
          const additionalAttr = t.key === "Ship Date" ? 'data-hidden-property="true"' : '';
          n.insertAdjacentHTML("beforeEnd", `<input ${r} ${additionalAttr} type="hidden" name="properties[${t.key}]" value="${t.value}">`)
        }))
      }
    }
    
    _removeProperties() {
      t.getPropertyInputElements().map((t => t.remove()))
    }
  }
  
  window && void 0 !== window?.ElsPreOrder && function(n) {
    if (!t.isProductPage()) return;
    const r = document.querySelector("variant-picker"),
      i = new e;
    if (r) {
      const t = setInterval((() => {
        "function" == typeof r?.getSelectedOptions && (clearInterval(t), a(), r.addEventListener("change", a))
      }), 10)
    } else ! function() {
      const e = t.getProduct();
      if (!e || !e?.variants?.length || e?.variants?.length > 1) return;
      const n = i.getPrepareVariant(e.variants[0]);
      n && i.renderPreOrderButton(n, (t => {
        t.find((t => t.classList.contains("bold_hidden")))
      }))
    }();

    function a(t = null) {
      const e = r.getSelectedOptions(),
        n = r.data.product.variants.findIndex((t => t.options.every(((t, n) => t === e[n])))),
        a = r.data.product.variants[n];
      if (a && a) {
        const e = i.getPrepareVariant(a);
        e && (t ? (r.data.product.variants[n] = e, r.handleVariantChange(t)) : (r.variant = e, r.updateAddToCartButton(), r.updateAvailability(), r.updatePrice(), r.updateBackorderText(), r.updatePickupAvailability(), r.updateSku()), i.renderPreOrderButton(e, (t => {
          const e = t.find((t => t.classList.contains("bold_hidden")));
          e && (t.map((t => {
            r.addBtn = t, r.updateAddToCartButton()
          })), r.addBtn = e)
        })))
      }
    }
  }()
})();